import React, {Fragment} from 'react';

interface IProps {
  label: string,
  searchTerm: string;
}

export const getSearchTermRegexPattern = (searchTerm: string[]): string => {
    return searchTerm.map((term: string, index: number): string => {
        if (index === searchTerm.length - 1) {
            return `${term}`
        } else {
            return `${term}|`
        }
    }).toString().replace(/,/g, '')
 }
 
 export const formatSearchText = (text: string): string => {
     return text.toLowerCase().replace(/[\W_]+/g, ' ')
 }
 
 export const cleanLocationText = (text: string): string => {
     return text.replace(/, ,/g, ',')
 }

const Suggestion: React.FC<IProps> = ({ label, searchTerm}) => {
  const searchQuery = getSearchTermRegexPattern(formatSearchText(searchTerm.trim()).split(' '))
  const cleanText = cleanLocationText(label)
  const whitespaceSplit: RegExpMatchArray | null = cleanText.match(/\S+\s*/g)
  const regex = new RegExp(`\\b(${searchQuery})`, 'ig')
  const textSplit: string[] | null = whitespaceSplit === null
      ? null
      : whitespaceSplit.map((txt: string) => txt.split(/(-)/g)).reduce((acc, val) => acc.concat(val), [])

  if (textSplit === null) {
      return <span>{cleanText}</span>
  }

  return (
      <Fragment>
          {textSplit.map((txt: string, index: number) => {
              const match:  RegExpMatchArray | null = txt.match(regex)
              if (match !== null) {
                  return (
                      <Fragment key={index}>
                          <strong className="font-bold">{txt.substring(0, match[0].length)}</strong>
                          <span>{txt.substring(match[0].length)}</span>
                      </Fragment>
                  )
              } else {
                  return <span key={index}>{txt}</span>
              }
          })}
      </Fragment>
  );
}

export default Suggestion;
